import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__links" }
const _hoisted_3 = { class: "footer__contact" }
const _hoisted_4 = {
  href: "https://t.me/TenderAsiaSupport",
  target: "_blank",
  class: "btn btn-gray"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-telegram" }, null, -1)
const _hoisted_6 = {
  href: "mailto:info@tender.asia",
  class: "btn btn-gray btn--w-icon"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-mail" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass({ 'inner-footer': _ctx.isInner })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'container': !_ctx.isInner })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/user_agreement" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("user_agreement.title")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/privacy_and_terms" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("privacy_and_terms.title")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("footer.contact_telegram")), 1)
          ]),
          _createElementVNode("a", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("footer.contact_email")), 1)
          ])
        ])
      ])
    ], 2)
  ], 2))
}